import makeStyles from "@mui/styles/makeStyles";
export const useCheckboxStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    width: 24,
    height: 24,
    padding: 0,
    "& .Checkbox": {
      fill: theme.palette.grey[600],
    },
    "& .Checkbox-focus": {
      opacity: 0,
      // TODO: find alternate
      // fill: alpha(theme.palette.primary.main, 0.2),
    },
    "&:hover": {
      background: "transparent !important",
      "& .Checkbox": {
        fill: theme.palette.grey[900],
      },
    },
    "&:focus-within": {
      "& .Checkbox-focus": {
        opacity: 1,
      },
    },
    "&.Mui-checked": {
      "&:focus-within": {
        color: theme.palette.primary.dark,
      },
    },
    "&.MuiCheckbox-colorPrimary.Mui-disabled": {
      color: theme.palette.grey[200],
    },
    "&[aria-disabled=true]": {
      cursor: "default",
      pointerEvents: "auto !important",
      "& .Checkbox": {
        fillRule: "initial",
        fill: theme.palette.grey[300],
      },
      "& .Checkbox-focus": {
        fill: theme.palette.grey[200],
      },
      "&.Mui-checked": {
        "&:focus-within": {
          color: theme.palette.grey[300],
        },
      },
      "&:hover": {
        "& .Checkbox": {
          fill: theme.palette.grey[300],
        },
      },
    },
  },
}));

export const useStyles = makeStyles(() => ({
  tooltipWrap: {
    width: 24,
    height: 24,
  },
}));
